import CustomLinkButton from "./custom-link-button";

const OpinionCard = ({ fullName, role, opinion, links }) => {
    return (
        <div class="flex flex-col justify-between overflow-hidde rounded-3xl bg-base-100 text-base shadow-2xl px-6 md:px-10 py-2">
            <div class="md:py-2">
                <p class="mt-5 font-semibold">"{opinion}"</p>
            </div>
            <div class="py-4">
                <hr class="bg-current h-[1px] border-0" />
                <div class="mt-5">
                    <p class="text-2xl font-bold">{fullName}</p>
                    <p class="opacity-80">{role}</p>
                </div>
                <div class="flex gap-x-2 mt-3">
                    {links && links.map((link, index) => (
                        <CustomLinkButton key={index} style_classes={"custom-primary-white-btn"} size={link.size} link={link.link} path={link.path} />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default OpinionCard;